import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { Pencil, LayoutGrid, Play, Film } from "lucide-react";

const ICONS = [Pencil, LayoutGrid, Play, Film];

export default function Process() {
  const { t } = useLang();
  return (
    <section id="process" className="bg-[#f5f5f5] py-24 lg:py-32">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8a8a8a] mb-3">
            · {t.process.label}
          </div>
          <h2 className="font-mono font-bold tracking-tighter text-3xl sm:text-4xl lg:text-5xl text-[#0a0a0a]">
            {t.process.title}
          </h2>
        </div>

        <div className="relative">
          {/* Horizontal line on desktop */}
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-px bg-[#0a0a0a]" />

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-10 lg:gap-6">
            {t.process.steps.map((s, i) => {
              const Icon = ICONS[i];
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.08 }}
                  className="relative"
                >
                  {/* Dot on timeline */}
                  <div className="hidden lg:flex items-center justify-center mb-8">
                    <div className="relative w-6 h-6 bg-[#f5f5f5]">
                      <div
                        className="absolute inset-1.5 rounded-full"
                        style={{ background: i % 2 === 0 ? "#00d4ff" : "#ff006e" }}
                      />
                    </div>
                  </div>

                  <div className="lg:text-center">
                    <div className="inline-flex items-center gap-3 lg:flex-col lg:items-center lg:gap-2">
                      <div className="w-12 h-12 border border-[#0a0a0a] bg-white flex items-center justify-center">
                        <Icon size={18} className="text-[#0a0a0a]" />
                      </div>
                      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8a8a8a]">
                        STEP {String(i + 1).padStart(2, "0")}
                      </div>
                    </div>
                    <h3 className="mt-4 font-mono font-medium text-lg sm:text-xl text-[#0a0a0a]">
                      {s.title}
                    </h3>
                    <p className="mt-2 font-sans text-sm text-[#4a4a4a] leading-relaxed lg:max-w-xs lg:mx-auto">
                      {s.desc}
                    </p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
